// Types
import { PERMISION } from "security"
import type { MenuType } from "../types"

export const salesMenu = {
  menu: [
    {
      label: "REGISTER",
      link: "/sales/register",
      permission: PERMISION.SALES.REGISTER.PERMISION
    },
    {
      label: "TRANSACTION",
      link: "#",
      permission: PERMISION.SALES.TRANSACTION.PERMISION,
      children: [
        { label: "CUSTOMER QUOTATION", link: "/sales/transaction/customer-quotation", permission: PERMISION.SALES.TRANSACTION.CUSTOMER_QUOTATION.PERMISION },
        { label: "CREATE RETURNED RECORD", link: "/sales/transaction/return-record", permission: PERMISION.SALES.TRANSACTION.CREATE_RETURNED_RECORD.PERMISION },
        { label: "CUSTOMER QUOTATION APPROVAL", link: "/sales/transaction/approve-quotation", permission: PERMISION.SALES.TRANSACTION.CUSTOMER_QUOTATION_APPROVAL.PERMISION },
        { label: "CUSTOMER ORDER", link: "/sales/transaction/customer-order", permission: PERMISION.SALES.TRANSACTION.CUSTOMER_ORDER.PERMISION },
        { label: "CUSTOMER ORDER APPROVAL", link: "/sales/transaction/approve-so", permission: PERMISION.SALES.TRANSACTION.CUSTOMER_ORDER_APPROVAL.PERMISION },
        { label: "CUSTOMER DEPOSIT APPROVAL", link: "/sales/transaction/approve-depo-customer", permission: PERMISION.SALES.TRANSACTION.CUSTOMER_DEPOSIT_APPROVAL.PERMISION },
        { label: "INVOICE APPROVAL", link: "/sales/transaction/approve-invoice", permission: PERMISION.SALES.TRANSACTION.INVOICE_APPROVAL.PERMISION },
        { label: "PAYMENT INVOICE APPROVAL", link: "/sales/transaction/approve-payment-invoice", permission: PERMISION.SALES.TRANSACTION.PAYMENT_INVOICE_APPROVAL.PERMISION },
        { label: "RETURN ITEMS APPROVAL", link: "/sales/transaction/approve-return-items", permission: PERMISION.SALES.TRANSACTION.RETURN_ITEMS_APPROVAL.PERMISION },
        { label: "REFUND RETURN APPROVAL", link: "/sales/transaction/approve-return-refund", permission: PERMISION.SALES.TRANSACTION.REFUND_RETURN_APPROVAL.PERMISION },
        { label: "ADJUSTMENT FREIGHT INVOICE", link: "/sales/transaction/adjustment-freight/list", permission: PERMISION.SALES.TRANSACTION.ADJUSTMENT_FREIGHT_INVOICE.PERMISION },
      ]
    },
    { 
      label: "REPORT",
      link: "#",
      permission: PERMISION.SALES.REPORT.PERMISION,
      children: [
        { label: "AGING SUMMARY", link: "/sales/report/aging-summary", permission: PERMISION.SALES.REPORT.AGING_SUMMARY.PERMISION },
        { label: "AGING DETAIL", link: "/sales/report/ageng-detail", permission: PERMISION.SALES.REPORT.AGING_DETAIL.PERMISION },
        { label: "SALES SUMMARY", link: "/sales/report/sales-summary", permission: PERMISION.SALES.REPORT.SALES_SUMMARY.PERMISION },
        { label: "ANALYSE SALES - PERIODE", link: "/sales/report/analyse-sales-periode", permission: PERMISION.SALES.REPORT.ANALYSE_SALES_PERIODE.PERMISION },
        { label: "ANALYSE SALES - COMPARATION", link: "/sales/report/analyse-sales-comparation", permission: PERMISION.SALES.REPORT.ANALYSE_SALES_COMPARATION.PERMISION },
        { label: "ANALYSE SALES - MONTHLY", link: "/sales/report/analyse-sales-monthly", permission: PERMISION.SALES.REPORT.ANALYSE_SALES_MONTHLY.PERMISION },
        { label: "CUSTOMER SALES DETAIL", link: "/sales/report/customer-sales-detail", permission: PERMISION.SALES.REPORT.CUSTOMER_SALES_DETAIL.PERMISION },
        { label: "SALESPERSON SALES SUMMARY", link: "/sales/report/salesperson-sales-summary", permission: PERMISION.SALES.REPORT.SALESPERSON_SALES_SUMMARY.PERMISION },
        { label: "SALESPERSON SALES DETAIL", link: "/sales/report/salesperson-sales-detail", permission: PERMISION.SALES.REPORT.SALESPERSON_SALES_DETAIL.PERMISION },
        { label: "ALL SALES", link: "/sales/report/all-sales", permission: PERMISION.SALES.REPORT.ALL_SALES.PERMISION },
        { label: "PAYMENT HISTORY", link: "/sales/report/payment-history", permission: PERMISION.SALES.REPORT.PAYMENT_HISTORY.PERMISION },
        { label: "SALES RECEIVABLE JOURNAL", link: "/sales/report/sales-receivable-journal", permission: PERMISION.SALES.REPORT.SALES_RECEIVALBLE_JOURNAL.PERMISION },
        { label: "DASHBOARD", link: "/sales/report/dashboard", permission: PERMISION.SALES.REPORT.DASHBOARD.PERMISION }
      ]
    },
    {
      label: "JOURNAL",
      link: "/sales/journal",
      permission: PERMISION.SALES.JOURNAL.PERMISION
    },
    {
      label: "FIND",
      link: "/sales/find",
      permission: PERMISION.SALES.FIND.PERMISION
    }
  ] as MenuType[]
}
